import { Aspect } from '@teambit/harmony';

export const PubsubAspect = Aspect.create({
  id: 'teambit.harmony/pubsub',
  dependencies: [],
});

export default PubsubAspect;
